/*
  Keyboard/screen-reader support for product variant option controls.

  app.js `updateOptions()` wipes the swatch container with `option.innerHTML = ''`
  and re-appends rebuilt wrappers. That tears out the element the user is standing
  on, so document.activeElement resets to <body> and the screen reader's virtual
  cursor restarts at the top of the page. app.js is a generated asset the Asset API
  refuses to write, so focus is restored from here instead.

  Importantly the rebuild happens MORE THAN ONCE per change: once synchronously
  (~80ms) and again after the variant data resolves (~490ms, observed). A fixed
  timer therefore restores focus only for it to be destroyed by the later rebuild —
  which is why arrowing onto the last swatch used to drop focus. So this is driven
  by a MutationObserver on the option container rather than by timing: every
  rebuild inside the window re-asserts focus.
*/
(function () {
  'use strict';

  var VALUE = '[data-variant-option-value]';
  var WINDOW_MS = 3000; // how long after a change we keep re-asserting focus

  var pending = null;
  var deadline = 0;
  var observer = null;
  var disconnectTimer = null;

  function describe(input) {
    return {
      index: input.getAttribute('data-variant-option-value-index'),
      value: input.getAttribute('value'),
      name: input.getAttribute('name'),
    };
  }

  function findMatch(target) {
    if (!target) return null;
    var all = document.querySelectorAll(VALUE);
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (
        el.getAttribute('data-variant-option-value-index') === target.index &&
        el.getAttribute('value') === target.value &&
        el.getAttribute('name') === target.name
      ) {
        return el;
      }
    }
    return null;
  }

  function restore() {
    if (!pending || Date.now() > deadline) return;
    // Only reclaim focus the rebuild orphaned — never steal it from a user who has
    // deliberately moved on.
    if (document.activeElement && document.activeElement !== document.body) return;
    var match = findMatch(pending);
    if (match) match.focus();
  }

  function stopObserving() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (disconnectTimer) {
      clearTimeout(disconnectTimer);
      disconnectTimer = null;
    }
    pending = null;
  }

  // Scoped to the option container that is actually being rebuilt, and torn down
  // when the window expires. Observing document.body/subtree would fire on every
  // DOM mutation on the page — and these pages run a chat widget, carousels and a
  // reviews app that mutate constantly.
  function startObserving(input) {
    if (typeof MutationObserver === 'undefined') return;
    var scope =
      input.closest('variant-selection') ||
      input.closest('options-selection') ||
      input.closest('fieldset.swatch') ||
      input.parentElement;
    if (!scope) return;

    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      window.requestAnimationFrame(restore);
    });
    observer.observe(scope, { childList: true, subtree: true });

    if (disconnectTimer) clearTimeout(disconnectTimer);
    disconnectTimer = setTimeout(stopObserving, WINDOW_MS);
  }

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target && e.target.closest ? e.target.closest(VALUE) : null;
      if (!input) return;
      pending = describe(input);
      deadline = Date.now() + WINDOW_MS;
      startObserving(input);
      // Cover the synchronous rebuild too, in case it produces no observable
      // mutation batch before the next frame.
      window.requestAnimationFrame(restore);
    },
    true
  );
})();
